import {Utilities} from '@shared/utilities/utilities.model';
import {DateUtilities} from '@shared/utilities/date-utilities.model';

export interface CalendarModelI {
    id: string;
    type: string;
    date: string;
    datetime_start: string;
    datetime_end: string;
    title: string;
    description: string;
    ald_reference_type: string;
    ald_reference_id: number;
    place: PlaceCalendar;
    guests: GuestCalendar[];
    created_at: string;
    updated_at: string;
}

export class CalendarModel {

    static CONTRACTS = 'CONTRACTS';
    static DELIVERY  = 'DELIVERY';
	static CLOSING = 'RETURN';
	static EXCHANGE_1 = 'EXCHANGE_1';
	static EXCHANGE_2 = 'EXCHANGE_2';
    static AVAILABILITY = 'AVAILABILITY';

    id: string;
    type: string;
    date: string;
    datetime_start: string;
    datetime_end: string;
    title: string;
    description: string;
    ald_reference_type: string;
    ald_reference_id: string;
    place: PlaceCalendar;
    guests: GuestCalendar[];
    created_at: string;
    updated_at: string;

    constructor(model?: any) {
        this.guests = [];
        if (!Utilities.isVoid(model)) {
            const date = DateUtilities.getDate(model.datetime_start).setHours(0, 0, 0, 0);
            this.id = model.id;
            this.type = model.type;
            this.date = DateUtilities.getUTCStringFromDate(date);
            this.datetime_start = model.datetime_start;
            this.datetime_end = model.datetime_end;
            this.created_at = model.created_at;
            this.updated_at = model.updated_at;
            if (!Utilities.isVoid(model.place)) {
                this.place = new PlaceCalendar(model.place);
            }
            if (!Utilities.isVoid(model.guests)) {
                for (let i = 0; i < model.guests.length; i++) {
                    this.guests.push(new GuestCalendar(model.guests[i]));
                }
            }
        }
    }


}


export class PlaceCalendar {

    place_id: string;
    name: string;
    type: string;
    contact_phone: string;
    ald_commodity_id: string;
    address: string;
    lat: string;
    lng: string;

    constructor(model?: any) {
        if (!Utilities.isVoid(model)) {
            this.place_id = model.place_id;
            this.name = model.name;
            this.type = model.type;
            this.contact_phone = model.contact_phone;
            this.ald_commodity_id = model.ald_commodity_id;
            this.address = model.address;
            this.lat = model.lat;
            this.lng = model.lng;
        }
    }
}


export class GuestCalendar {

    name: string;
    mobile: string;
    type: string;
    user_id: string;
    is_owner: boolean;
    has_accepted: boolean;


    constructor(model?: any) {
        if (!Utilities.isVoid(model)) {
            this.name = model.name;
            this.mobile = model.mobile;
            this.type = model.type;
            this.user_id = model.user_id;
            this.is_owner = model.is_owner;
            this.has_accepted = model.has_accepted;
        }
    }
}
